import AgenciesCredentialsGrid from '../AgenciesCredentialsGrid';
import CredentialForm from '../CrendentialsForm';

import useCredentialForm from './CredentialsTab.hooks';

const CredentialsTab = () => {
  const { showCredentialForm } = useCredentialForm();

  return showCredentialForm ? <CredentialForm /> : <AgenciesCredentialsGrid />;
};

export default CredentialsTab;
